module.exports = __webpack_public_path__ + "static/media/ion2.975dcdca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ion2.svg
// module id = 132
// module chunks = 0